<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  description: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <BasicBlock
    :icon="['far', 'message-lines']"
    :text="description"
    :aria-label="$t('global.description')"
  >
  </BasicBlock>
</template>
